// All narrative copy for the "Take Krishna Home" experience, in English + Hindi.
// Text only — scroll timings live in the Landing page.
export const translations = {
  en: {
    dir: "ltr",
    nav: { brand: "Take Krishna Home", wish: "Happy Janmashtami" },
    langName: "English",
    langShort: "EN",
    hero: {
      small: "This Janmashtami",
      title: "Take Krishna Home",
      scroll: "Start Scrolling",
    },
    stories: [
      {
        kicker: "Before Krishna appeared…",
        title: "One who carries Krishna\nbecomes glorious.",
        body: "Mother Devaki carries Krishna within. Even the demigods descend to offer their prayers. She is Krishna-vahā — the one who carries Krishna.",
      },
      {
        kicker: "At midnight…",
        title: "Hope entered\nthe darkest place.",
        body: "Krishna appeared in the prison of Mathura.",
      },
      {
        kicker: "When you carry Krishna…",
        title: "Nothing can\nimprison you.",
        body: "The chains broke. The prison doors opened. No obstacle remained. Vasudeva became Krishna-vahā — one who carries Krishna finds impossible doors opening.",
      },
      {
        kicker: "Even nature makes way.",
        title: "The Yamuna\nparted.",
        body: "The storm calmed, because Krishna was being carried. Everything serves the one who carries the Lord.",
      },
      {
        kicker: "Krishna arrives home.",
        title: "Joy follows\nwherever Krishna resides.",
        body: "Nanda Maharaj, Mother Yashoda, and all of Vraja — their hearts overflow, because they carry Krishna.",
      },
    ],
    transition: {
      heading: "What if you could carry Krishna too?",
      lines: [
        "For thousands of years…",
        "everyone who carried Krishna was transformed.",
        "Mother Yashoda.",
        "Vasudeva.",
        "Nanda Maharaj.",
        "The residents of Vraja.",
        "Even the Yamuna.",
      ],
      now: ["Now…", "Will you carry Krishna?"],
      closing: ["This Janmashtami…", "Take Krishna Home."],
    },
    second: {
      title: "Take Krishna Home.",
      sub: "Every home becomes sacred when Krishna enters it.",
      cta: "Show Me How",
      placeholder: "The hand animation will live here.",
    },
    paths: {
      heading: "Four Sacred Ways to Carry Krishna",
      sub: "There are many ways to remember Krishna. Here are four sacred ways to carry Him with you, wherever you go.",
      eyebrow: "Carry Krishna through",
      primaryTag: "The heart of it",
      scratchHint: "Scratch to reveal",
      footer: "Choose the way that speaks to your heart and begin your journey of becoming Krishna-vahā.",
      footerAccent: "One who carries Krishna is never alone.",
      items: [
        {
          title: "Mahaprasadam",
          desc: "Accept His mercy through sanctified prasadam and let Him nourish your body and soul.",
          cta: "Receive Mahaprasadam",
        },
        {
          title: "His Holy Name",
          desc: "Chant His holy names and take Krishna with you in every step, every breath, every moment.",
          cta: "Begin Chanting",
        },
        {
          title: "His Darshan",
          desc: "Invite His beautiful form into your home and let His presence bless your family and life.",
          cta: "Bring Home Darshan",
        },
        {
          title: "Srimad Bhagavatam",
          desc: "Read, hear and keep the eternal story of Krishna in your heart — the highest and most complete way to carry Him.",
          cta: "Bring Home Srimad Bhagavatam",
        },
      ],
    },
    final: {
      small: "This Janmashtami…",
      title: "Take Krishna Home.",
      cta: "Begin Your Journey",
    },
  },

  hi: {
    dir: "ltr",
    nav: { brand: "कृष्ण को घर लाइए", wish: "शुभ जन्माष्टमी" },
    langName: "हिन्दी",
    langShort: "हिं",
    hero: {
      small: "इस जन्माष्टमी",
      title: "कृष्ण को घर लाइए",
      scroll: "यात्रा आरंभ करें",
    },
    stories: [
      {
        kicker: "कृष्ण के प्रकट होने से पहले…",
        title: "जो कृष्ण को धारण करती है,\nवह महिमामयी हो जाती है।",
        body: "माता यशोदा अपने भीतर कृष्ण को धारण करती हैं। देवता भी उन्हें प्रणाम करने उतर आते हैं। वे हैं कृष्ण-वाहा — जो कृष्ण को धारण करती हैं।",
      },
      {
        kicker: "अर्धरात्रि में…",
        title: "सबसे गहन अंधकार में\nआशा का संचार हुआ।",
        body: "कृष्ण मथुरा के कारागार में प्रकट हुए।",
      },
      {
        kicker: "जब आप कृष्ण को धारण करते हैं…",
        title: "कोई बंधन\nआपको बाँध नहीं सकता।",
        body: "बेड़ियाँ टूट गईं। कारागार के द्वार खुल गए। कोई बाधा शेष न रही। वसुदेव कृष्ण-वाहा बन गए — जो कृष्ण को धारण करता है, उसके लिए असंभव द्वार भी खुल जाते हैं।",
      },
      {
        kicker: "प्रकृति भी मार्ग दे देती है।",
        title: "यमुना ने\nमार्ग दे दिया।",
        body: "तूफ़ान शांत हो गया, क्योंकि कृष्ण को धारण किया जा रहा था। जो प्रभु को धारण करता है, सब कुछ उसकी सेवा करता है।",
      },
      {
        kicker: "कृष्ण घर पधारते हैं।",
        title: "जहाँ कृष्ण निवास करते हैं,\nवहाँ आनंद स्वयं आता है।",
        body: "नंद महाराज, माता यशोदा और समस्त व्रजवासी — उनके हृदय आनंद से भर उठते हैं, क्योंकि वे कृष्ण को धारण करते हैं।",
      },
    ],
    transition: {
      heading: "क्या हो, यदि आप भी कृष्ण को धारण कर सकें?",
      lines: [
        "हज़ारों वर्षों से…",
        "जिसने भी कृष्ण को धारण किया, वह रूपांतरित हो गया।",
        "माता यशोदा।",
        "वसुदेव।",
        "नंद महाराज।",
        "व्रज के वासी।",
        "और यमुना भी।",
      ],
      now: ["अब…", "क्या आप कृष्ण को धारण करेंगे?"],
      closing: ["इस जन्माष्टमी…", "कृष्ण को घर लाइए।"],
    },
    second: {
      title: "कृष्ण को घर लाइए।",
      sub: "जब कृष्ण प्रवेश करते हैं, तब हर घर पवित्र हो जाता है।",
      cta: "मुझे मार्ग दिखाइए",
      placeholder: "हस्त-एनिमेशन यहाँ आएगा।",
    },
    paths: {
      heading: "कृष्ण को धारण करने के चार पावन मार्ग",
      sub: "कृष्ण को स्मरण करने के अनेक मार्ग हैं। यहाँ चार पावन मार्ग हैं, जिनसे आप उन्हें हर जगह अपने साथ रख सकते हैं।",
      eyebrow: "कृष्ण को धारण करें",
      primaryTag: "सबसे विशेष",
      scratchHint: "खुरचें और देखें",
      footer: "अपने हृदय की पुकार सुनें और कृष्ण-वाहा बनने की यात्रा आरंभ करें।",
      footerAccent: "जो कृष्ण को धारण करता है, वह कभी अकेला नहीं होता।",
      items: [
        {
          title: "महाप्रसाद",
          desc: "पवित्र प्रसाद के माध्यम से उनकी कृपा स्वीकार करें और उन्हें अपने तन-मन का पोषण करने दें।",
          cta: "महाप्रसाद प्राप्त करें",
        },
        {
          title: "उनके पवित्र नाम",
          desc: "उनके पवित्र नामों का जप करें और हर पल, हर साँस में कृष्ण को अपने साथ रखें।",
          cta: "जप आरंभ करें",
        },
        {
          title: "उनके दर्शन",
          desc: "उनके सुंदर स्वरूप को अपने घर आमंत्रित करें और उनकी उपस्थिति से अपने परिवार को धन्य करें।",
          cta: "दर्शन घर लाएँ",
        },
        {
          title: "श्रीमद्भागवतम्",
          desc: "कृष्ण की शाश्वत कथा को पढ़ें, सुनें और हृदय में धारण करें — उन्हें धारण करने का सर्वोच्च मार्ग।",
          cta: "श्रीमद्भागवतम् घर लाइए",
        },
      ],
    },
    final: {
      small: "इस जन्माष्टमी…",
      title: "कृष्ण को घर लाइए।",
      cta: "अपनी यात्रा आरंभ करें",
    },
  },
};
